import React, { FC, ReactNode, useContext } from 'react';
import { Icon }                             from 'semantic-ui-react';
import { Cell, Grid }                       from "styled-css-grid";
import _                                    from 'underscore';

import { Size }                            from '@src/types';
import { LangService }                     from '@src/services';
import { StyledContainer }                 from '@src/views/containers';
import { DashboardProjectListItemContext } from './ProjectListItem';


interface DetailFieldObject {
    label: string,
    value: string,
    icon?: ReactNode | null
}

interface Props {}

const defaultProps: Props = {}

const ProjectListItemDetails: FC<Props> = ( props ) => {

    let { project } = useContext( DashboardProjectListItemContext );

    let termDictionary = LangService.getDictionary( project.termDictionary ),
        dictionaryHash = {
            assetNameLabel:       LangService.getTermFromDictionary( 'PROJECT_DETAILS.ASSET_NAME.LABEL', termDictionary ),
            assetIndicationLabel: LangService.getTermFromDictionary( 'PROJECT_DETAILS.ASSET_INDICATION.LABEL', termDictionary )
        };

    let detailFields: DetailFieldObject[] = _.compact( [
        {
            label: dictionaryHash.assetNameLabel,
            value: project.assetName,
            icon:  <Icon name={ 'cube' } color={ 'teal' } fitted/>
        },
        {
            label: dictionaryHash.assetIndicationLabel,
            value: project.assetIndication,
            icon:  <Icon name={ 'cube' } color={ 'teal' } fitted/>
        }
    ] );

    return (

        <StyledContainer padding={ [ Size.SM, null ] }>

            <Grid columns={ `auto minmax(auto, 200px) 38% 1fr` } rowGap={ `` }>

                { detailFields.map( ( detail, index ) => (

                    <React.Fragment key={ index }>
                        <Cell center>{ detail.icon ?? null }</Cell>
                        <Cell><strong>{ detail.label }:</strong></Cell>
                        <Cell>{ detail.value }</Cell>
                        <Cell></Cell>
                    </React.Fragment>

                ) ) }
            </Grid>

        </StyledContainer>
    );
};

ProjectListItemDetails.defaultProps = defaultProps;

export { ProjectListItemDetails }
